import {Component, OnInit, ViewChild} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {ModalComponent} from 'app/core/modal.component';
import {WorkersModelService} from 'app/models/workers-model.service';
import {ListComponent} from 'app/components/ui/list/item';
import {ApiResponse} from 'app/entities/apiResponse.entity';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

// DON'T FORGET INCLUDE MODULE OF MODAL INTO PAGE MODULE, or it will not work
@Component({
  selector: 'app-workers-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class WorkersModalComponent extends ModalComponent implements OnInit {

  @ViewChild('workersList') workersList: ListComponent;

  inputData: any;

  pageLoading = true;
  listLoading = false;
  responseData: ApiResponse;

  searchForm: FormGroup;
  formBuilder: FormBuilder;

  filters: any = {
    search: null as string,
    positions: null as [],
    branches: null as [],
    function: null as string,
    onShift: false as boolean,
  };

  workersModelService: WorkersModelService;

  constructor(
    modalController: ModalController,
    workersModelService: WorkersModelService,
    formBuilder: FormBuilder,
  ) {
    super(modalController);

    this.workersModelService = workersModelService;

    this.formBuilder = formBuilder;
  }

  ngOnInit() {
    console.log('inputData', this.inputData);
    this.setInputFilters();
    this.buildSearchForm();
  }

  ionViewWillEnter() {
    // this.pageLoading = true;

    this.workersList.loadItems(true).then(()=> {
      this.workersList.afterLoad.subscribe((res: any) => {
        if (res) {
          this.responseData = res.data;
        }
      });
    });
  }

  loadFinished() {
    this.pageLoading = false;
    this.listLoading = false;
  }

  setInputFilters() {
    if (this.inputData.filters && Object.keys(this.inputData?.filters).length > 0) {
      console.log('setInputFilters:');

      Object.keys(this.inputData?.filters).forEach((key) => {
        console.log(key, this.inputData?.filters[key]);
        this.filters[key] = this.inputData?.filters[key];
      });

      console.log('this.filters', this.filters);
    }
  }

  buildSearchForm() {
    this.searchForm = this.formBuilder.group({
      search: ['', [
        Validators.required
      ]]
    });
  }

  applyFilters() {
    this.listLoading = true;
    this.workersList.loadItems(true);
  }

  // closeModal() {
  //   return super.closeModal({answer: 'answer'});
  // }
}
